import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { VideoSubmissionDto, VideoSubmissionStatus } from "../../../models/video-review/dto/video-submission.dto";

export const GET_VIDEO_SUBMISSIONS_QUERY_KEY = (organizationId: string, status?: VideoSubmissionStatus) =>
    ['video-submissions', 'list', organizationId, status];

export const useListVideoSubmissions = (organizationId: string, status?: VideoSubmissionStatus) => {
    const client = useApiClient();

    return useQuery({
        queryKey: GET_VIDEO_SUBMISSIONS_QUERY_KEY(organizationId, status),
        queryFn: () => {
            let endpoint = `video-submissions/list/all?organizationId=${organizationId}`;
            if (status) {
                endpoint += `&status=${status}`;
            }
            return client.fetchApi<VideoSubmissionDto[], {}>({
                endpoint,
                method: 'GET',
            });
        },
        staleTime: 30_000,
        enabled: !!organizationId,
    });
};
